import {
  clearCacheEnum,
  DashboardTypes,
  MetricsInfo,
  MetricsResponse,
  PlaceholderObject,
  UserQuery,
  calculatedMetricsDetail,
  detailedDimensionsDetail,
  metric,
  metricFunction,
  queryInput,
  DeleteStoredQueryMutation,
  BenchmarkingIndexValues,
} from 'API';
import { Add, StyledTableContainer, TxtContainer2 } from 'components/Main/table/TableStyles';
import { CCData, useDataQuery } from 'customHooks/useDataQuery';
import { fullSources } from 'customHooks/useDataSources';
import { useGetMainTotalQuery } from 'customHooks/useGetMainTotalQuery';
import { useGetStoredQuery } from 'customHooks/useGetStoredQuery';
import { platformLogoSelector } from 'methods/platformLogoSelector';

import React, { ChangeEvent, useContext, useEffect, useState, useRef } from 'react';
import PlatformContainer from './PlatformContainer';
import DimensionsContainer from './DimensionsContainer';
import MetricsContainer from './MetricsContainer';
import ConversionsContainer from './ConversionsContainer';
import OverviewContainer from './OverviewContainer';
import AuthContext from 'context/AuthContext';
import { prepQuery, prepQueryCC } from 'methods/prepQuery';
import { useCampaignContext } from 'context/CampaignContext';
import { useJoinData } from 'customHooks/useJoinData';
import SavedContainer from './SavedContainer';
import PreviewContainer from './PreviewContainer';
import { useTemplateContext } from 'context/TemplateContext';
import ReactLoading from 'react-loading';
import { useTheme } from 'styled-components';
import { placeholdersStatusType, PublishContext } from 'context/PublishContext';
import { updateCustomSource } from 'methods/updateCustomSource';
import { useGetLatestData } from './OVERWRITE_DATA/OverwriteMain';
import { useVideoParams } from 'customHooks/useParameters';
import { removeTypename } from 'methods/removeTypename';
import { IconButton } from 'components/style/Global';
import { API } from 'aws-amplify';
import { deleteStoredQuery } from 'graphql/mutations';
import APIContext from 'context/APIContext';
import DeleteConfirmationModal, { modalObject } from 'components/DeleteConfirmationModall';
import { set } from 'lodash';

export type PlaceholderType = {
  type: 'Chart' | 'Table';
  minor: number;
  id: string;
  query_id?: string;
  duplicated?: boolean;
  original_id?: string;
  original_minor?: string;
  new_position?: string;
  saved?: boolean;
};

type Props = {
  storedQueryDetails?: UserQuery;
  dataSources: fullSources[];
  componentID: string;
  isGraph: boolean;
  placeholderId?: string;
  queryId?: string;
  placeholderList?: PlaceholderType[];
  handleDuplicate?: (componentID: string, mainQueryID: string) => Promise<boolean>;
  element?: PlaceholderType;
  parentIndex?: number;
  orderLength?: number;
  moveElement?: (id: string, direction: 'UP' | 'DOWN') => void;
  isDragEnabled?: boolean;
  setTablePlaceholderList?: (value: React.SetStateAction<PlaceholderType[]>) => void;
  setStoredQueries?: React.Dispatch<React.SetStateAction<UserQuery[]>>;
  removeItemFromList?: (id: string) => void;
  savePlaceholderToOrder2?: (componentId: string) => void;
  updateTablePlaceholderDuplicate?: (
    queryId: string,
    id: string,
    isDupicated: boolean | undefined,
    newOriginalId?: string | undefined,
  ) => void;
};

export type placeholderMetrics = {
  metric?: string;
  description?: string | null | undefined;
  view?: (string | null)[] | null | undefined;
  isSelected?: boolean;
  detailedMetric?: metric;
};

export type placeholderDimensions = {
  dimension?: string;
  description?: string | null | undefined;
  view?: (string | null)[] | null | undefined;
  isSelected?: boolean;
  detailedDimension?: detailedDimensionsDetail;
  benchmarkable?: boolean;
};

export type placeholderFullSources = {
  isSelected?: boolean;
  source_name?: string;
  metrics?: placeholderMetrics[];
  dimensions?: placeholderDimensions[];
  name: string;
  icon?: JSX.Element;
  metaName: string;
  calcMetrics: Array<calculatedMetricsDetail & { isSelected?: boolean }>;
  customConversions?: Array<CCData>;
};

// const PlaceholderContainer = (props: Props) => {
const PlaceholderContainer = (props: Props) => {
  const { user, userIsASolutionsArchitect } = useContext(AuthContext);
  const { activeCampaign, dashType } = useCampaignContext();
  const { fetchedPlaceholders } = useTemplateContext();
  const {
    storedQueryDetails,
    dataSources,
    componentID,
    isGraph,
    placeholderId,
    queryId,
    placeholderList,
    handleDuplicate,
    element,
    parentIndex,
    orderLength,
    moveElement,
    isDragEnabled,
    setTablePlaceholderList,
    setStoredQueries,
    removeItemFromList,
    savePlaceholderToOrder2,
    updateTablePlaceholderDuplicate,
  } = props;
  const [placeHolderDataSource, setPlaceHolderDataSource] = useState<placeholderFullSources[]>([]);
  const [title, setTitle] = useState<any>('Add title here');
  const [queryError, setQueryError] = useState<string>('');
  const theme = useTheme();
  const [chartMetrics, setChartMetrics] = useState<Array<MetricsResponse>>([]);
  const [newQuery, setNewQuery] = useState<'OLD' | 'NEW' | 'BACK' | 'APPLY'>('OLD');
  const [page, setPage] = useState<number>(0);
  const [videoSource] = useVideoParams();
  const [isClearingCache, setIsClearingCache] = useState<boolean>(false);
  const [cacheStatus, setCacheStatus] = useState<'idle' | 'clearing' | 'cleared'>('idle');
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

  const isPlaceholderSaved = element?.saved;

  // THESE ARE STATES FOR  4 QUERIES
  const [userMainQuery, setUserMainQuery] = useState<queryInput>();
  const [userMainQueryTotal, setUserMainQueryTotal] = useState<queryInput>();
  const [userCCQuery, setUserCCQuery] = useState<queryInput>();
  const [userCCTotalQuery, setUserCCTotalQuery] = useState<queryInput>();
  const [userBenchmarkQuery, setUserBenchmarkQuery] = useState<queryInput>();
  const [userBenchmarkTotalQuery, setUserBenchmarkTotalQuery] = useState<queryInput>();
  const prevUserMainQueryRef = useRef<queryInput>();
  // CREATE QUERIES BASED ON STORED QUERYID
  const [mainQuery] = useGetStoredQuery(storedQueryDetails?.query_id as string, componentID);
  const [mainQueryTotal] = useGetMainTotalQuery(
    isGraph ? undefined : (mainQuery as queryInput),
    'MAIN',
    storedQueryDetails?.hideTotal ?? false,
    // true,
  );
  const [ccQuery] = useGetStoredQuery(storedQueryDetails?.query_id_cc as string, componentID);
  // OVO ISPOD NE RADI JER TOTAL CC SE NE PRIKAZUJE; IAKO DOBIJEM I QUERY I DATU
  const [ccQueryTotal] = useGetMainTotalQuery(isGraph ? undefined : (ccQuery as queryInput), 'CC');
  const [benchmarkQuery] = useGetStoredQuery(storedQueryDetails?.query_id_benchmark as string, componentID);
  const [benchmarkQueryTotal] = useGetMainTotalQuery(isGraph ? undefined : (benchmarkQuery as queryInput), 'BENCHMARK');
  // console.log('BENCHMARK QUERY TOTAL', benchmarkQueryTotal);
  // console.log('BENCHMARK QUERY', benchmarkQuery);
  const { updateOLArray, removePlaceholderfromPublishArray, placeholdersStatus, setPlaceholdersStatus } =
    useContext(PublishContext);
  const [defaultSelected, setDefaultSelected] = useState<boolean>(false);
  const [latestOverwrittenData] = useGetLatestData(placeHolderDataSource.filter((el) => el.isSelected)[0]);

  // Benchmark Index state
  const [benchmarkIndex, setBenchmarkIndex] = useState<BenchmarkingIndexValues | null>(
    storedQueryDetails?.benchmarkingIndex || null,
  );

  // Hide total state - initialized with backend value
  const [hideTotal, setHideTotal] = useState<boolean>(storedQueryDetails?.hideTotal ?? false);

  // Track when benchmark index changes to prevent page jump
  const benchmarkChangeRef = useRef<boolean>(false);

  // console.log('ALL PROPS AS AN OBJECT:', {
  //   storedQueryDetails: storedQueryDetails,
  //   dataSources: dataSources,
  //   componentID: componentID,
  //   isGraph: isGraph,
  //   placeholderId: placeholderId,
  //   queryId: queryId,
  //   placeholderList: placeholderList,
  //   element: element,
  //   parentIndex: parentIndex,
  //   orderLength: orderLength,
  //   isDragEnabled: isDragEnabled,
  // });

  // Sync benchmark query dimension names with main query
  useEffect(() => {
    // Check if main query actually changed (not just reference)
    const mainQueryChanged = prevUserMainQueryRef.current
      ? JSON.stringify(prevUserMainQueryRef.current) !== JSON.stringify(userMainQuery)
      : false;

    if (userMainQuery && userBenchmarkQuery && mainQueryChanged) {
      const updatedBenchmarkQuery = { ...userBenchmarkQuery };

      let hasChanges = false;
      updatedBenchmarkQuery.query.detailedDimensions = updatedBenchmarkQuery.query.detailedDimensions?.map(
        (benchmarkDim: any) => {
          // Find dimension with same column in the updated main query
          const updatedDimension = userMainQuery.query.detailedDimensions?.find(
            (mainDim: any) => mainDim?.column === benchmarkDim?.column,
          );

          if (updatedDimension && updatedDimension.name !== benchmarkDim.name) {
            // If name has changed, update the benchmark dimension
            hasChanges = true;
            return { ...benchmarkDim, name: updatedDimension.name };
          }

          return benchmarkDim;
        },
      );

      if (hasChanges) {
        setUserBenchmarkQuery(updatedBenchmarkQuery);
      }
    }

    // Update the ref for next comparison
    prevUserMainQueryRef.current = userMainQuery;
  }, [userMainQuery, userBenchmarkQuery]);
  const selectedDataSource = placeHolderDataSource.filter((el) => el.isSelected)[0];

  //IF STORED QUERY IS THERE, SET THE QUERIES
  useEffect(() => {
    if (mainQuery) {
      // props.componentID.startsWith('BVOD') && console.log('BVODICA', mainQuery);
      setUserMainQuery(mainQuery);
    }
  }, [mainQuery]);
  useEffect(() => {
    if (mainQueryTotal) {
      setUserMainQueryTotal(mainQueryTotal);
    }
  }, [mainQueryTotal]);
  useEffect(() => {
    if (ccQuery) {
      setUserCCQuery(ccQuery);
    }
  }, [ccQuery]);
  useEffect(() => {
    if (ccQueryTotal) {
      setUserCCTotalQuery(ccQueryTotal);
    }
  }, [ccQueryTotal]);
  useEffect(() => {
    if (benchmarkQuery) {
      setUserBenchmarkQuery(benchmarkQuery);
    }
  }, [benchmarkQuery]);

  useEffect(() => {
    if (benchmarkQueryTotal) {
      setUserBenchmarkTotalQuery(benchmarkQueryTotal);
    }
  }, [benchmarkQueryTotal]);

  // THESE ARE DATA RESULTS FROM USER GENERATED  QUERIES
  const [mainData, mainQueryStatus, , mainQueryID, mainOL] = useDataQuery({
    query: userMainQuery,
    querySource: 'QUERY',
  });
  const [mainTotalData, mainTotalQueryStatus, , , mainOLTotal] = useDataQuery({
    query: userMainQueryTotal,
    querySource: 'QUERY TOTAL',
  });
  const [ccData, ccQueryStatus, , ccQueryID, ccOL] = useDataQuery({ query: userCCQuery, querySource: 'QUERY' });
  const [ccTotalData, ccTotalQueryStatus, , , ccOLTotal] = useDataQuery({
    query: userCCTotalQuery,
    querySource: 'QUERY TOTAL',
  });
  const [benchmarkData, benchmarkQueryStatus, , benchmarkQueryID, benchmarkOL] = useDataQuery({
    query: userBenchmarkQuery,
    querySource: 'QUERY',
  });
  const [benchmarkTotalData, benchmarkTotalQueryStatus, , , benchmarkOLTotal] = useDataQuery({
    query: userBenchmarkTotalQuery,
    querySource: 'QUERY TOTAL',
  });
  // useEffect(() => {
  //   console.log('BENCHMARK DATA FOR:', componentID, benchmarkData, benchmarkQueryStatus, benchmarkQueryID);
  // }, [benchmarkQueryID]);

  // Handle cache clearing completion and status update
  useEffect(() => {
    if (isClearingCache) {
      // Check if all queries are completed (either DONE or NOT STARTED for CC queries if they don't exist)
      const isMainQueryDone = mainQueryStatus === 'DONE';
      const isMainTotalQueryDone = userMainQueryTotal
        ? mainTotalQueryStatus === 'DONE'
        : mainTotalQueryStatus === 'NOT STARTED';
      const isCCQueryDone = userCCQuery ? ccQueryStatus === 'DONE' : ccQueryStatus === 'NOT STARTED';
      const isCCTotalQueryDone = userCCTotalQuery
        ? ccTotalQueryStatus === 'DONE'
        : ccTotalQueryStatus === 'NOT STARTED';

      const allQueriesCompleted = isMainQueryDone && isMainTotalQueryDone && isCCQueryDone && isCCTotalQueryDone;
      const isSomeQueryRunning =
        !allQueriesCompleted &&
        (mainQueryStatus === 'RUNNING' ||
          mainTotalQueryStatus === 'RUNNING' ||
          ccQueryStatus === 'RUNNING' ||
          ccTotalQueryStatus === 'RUNNING');

      if (isSomeQueryRunning) {
        setCacheStatus('clearing');
      }

      if (allQueriesCompleted) {
        // console.log('All queries completed after cache clearing');
        // console.log('DATA AFTER CLEARING CACHE', mainData, mainTotalData, ccData, ccTotalData);

        // Update status to cleared and reset clearing flag after 2 seconds
        setCacheStatus('idle');
        setIsClearingCache(false);
        // setTimeout(() => {
        //   setIsClearingCache(false);
        //   setCacheStatus('idle');
        // }, 2000);
      }
    }
  }, [
    isClearingCache,
    mainQueryStatus,
    mainTotalQueryStatus,
    ccQueryStatus,
    ccTotalQueryStatus,
    userCCQuery,
    userCCTotalQuery,
    mainData,
    mainTotalData,
    ccData,
    ccTotalData,
    userMainQueryTotal,
  ]);

  const resetQueries = () => {
    setUserMainQuery(undefined);
    setUserMainQueryTotal(undefined);
    setUserCCQuery(undefined);
    setUserCCTotalQuery(undefined);
    setQueryError('');
    return;
  };

  const clearCache = () => {
    setTimeout(() => {
      setIsClearingCache(true);
      setCacheStatus('clearing');
      setQueryError('');
    }, 1000);
    // Add clearCache property to all queries
    if (userMainQuery) {
      setUserMainQuery({ ...userMainQuery, clearCache: clearCacheEnum.CLEAR });
    }
    if (userMainQueryTotal) {
      setUserMainQueryTotal({ ...userMainQueryTotal, clearCache: clearCacheEnum.CLEAR });
    }
    if (userCCQuery) {
      setUserCCQuery({ ...userCCQuery, clearCache: clearCacheEnum.CLEAR });
    }
    if (userCCTotalQuery) {
      setUserCCTotalQuery({ ...userCCTotalQuery, clearCache: clearCacheEnum.CLEAR });
    }
  };

  // READ STORED QUERIES AND IDENTIFY SELECTED PÆATFORM; METRICS; DIMENSIONS; CALC METRICS
  useEffect(() => {
    const lookupPlaceHolderName = (viewName: string) => {
      if (viewName.includes('adform')) {
        return 'Adform';
      } else if (viewName.includes('facebook')) {
        return 'Facebook';
      } else if (viewName.includes('google_ads_video')) {
        return 'Youtube';
      } else if (viewName.includes('google_ads_display')) {
        return 'Google Ads';
      } else if (viewName.includes('campaign_manager') && !viewName.includes('olv')) {
        return 'CM';
      } else if (viewName.includes('linkedin')) {
        return 'LinkedIn';
      } else if (viewName.includes('_tv_')) {
        return 'TV';
      } else if (viewName.includes('_radio_')) {
        return 'RADIO';
      } else if (viewName.includes('print')) {
        return 'PRINT';
      } else if (viewName.includes('outdoor')) {
        return 'OOH';
      } else if (viewName.includes('cinema')) {
        return 'CINEMA';
      } else if (viewName.includes('snapchat')) {
        return 'Snapchat';
      } else if (viewName.includes('tiktok')) {
        return 'TikTok';
      } else if (viewName.includes('readpeak')) {
        return 'readpeak';
      } else if (viewName.includes('taboola')) {
        return 'Taboola';
      } else if (viewName.includes('pinterest')) {
        return 'Pinterest';
      } else if (viewName.includes('marathon')) {
        return 'Marathon';
      } else if (viewName.includes('campaign_manager_olv')) {
        return 'Online Video';
      } else if (viewName.includes('adform_olv')) {
        return 'Online Video';
      } else if (viewName.endsWith('google_dv360_youtube_')) {
        return 'DV360(YouTube)';
      } else if (viewName.includes('google_dv360_youtube_excluded_') || viewName.includes('google_dv360_conversions')) {
        return 'DV360';
      } else if (viewName.includes('google_ads_search_')) {
        return 'SEARCH';
      } else if (viewName.includes('tradedesk')) {
        return 'TradeDesk';
      } else if (viewName.includes('amazondsp')) {
        return 'Amazon Ads';
      } else if (viewName.includes('Custom')) {
        return 'Custom';
      } else {
        return 'Unknown';
      }
    };

    if (
      mainQuery &&
      dataSources.length > 0 &&
      (storedQueryDetails?.position === componentID || storedQueryDetails?.position === placeholderId)
    ) {
      const slicedViewNamesArray = mainQuery.views.map((el) => {
        const parts = el?.viewName.split('_') as string[];
        return parts.length > 2 ? parts.slice(1, 2).join('_') : '';
      });
      const allItemsAreSame = slicedViewNamesArray.every((item) => item === slicedViewNamesArray[0]);

      const activeSourceInfo = !allItemsAreSame ? 'Custom' : (mainQuery.views[0]?.viewName ?? '');
      const metrics = mainQuery.query.metrics;
      const dimensions = mainQuery.query.detailedDimensions;
      const calcMetrics = mainQuery.query.calculatedMetrics;
      const clonedDataSources0 = dataSources.map((el) => structuredClone(el)) as placeholderFullSources[];
      const clonedDataSources = clonedDataSources0.map((el) => {
        return {
          ...structuredClone(el),
          icon: platformLogoSelector(el.name),
        } as placeholderFullSources;
      });
      // setPlaceHolderDataSource(clonedDataSources);
      setTitle(storedQueryDetails?.title);
      const metricsArray = storedQueryDetails?.metrics;
      //remove duplicates from metricsArray
      const uniqueMetrics = metricsArray?.filter((v, i, a) => a.findIndex((t) => t?.metric === v?.metric) === i);
      setChartMetrics(uniqueMetrics as MetricsResponse[]);
      clonedDataSources.map((el) => {
        return { ...el, icon: platformLogoSelector(el.name) };
      });
      if (activeSourceInfo === '') {
        setPlaceHolderDataSource(clonedDataSources);
      } else {
        const dataSourcesWithSelectedPlatform = clonedDataSources.map((el) => {
          const lookupName = lookupPlaceHolderName(activeSourceInfo);
          if (lookupName === 'Unknown') {
            const secondaryLookup = mainQuery.views[1]?.viewName ?? '';
            if (el.name === lookupPlaceHolderName(secondaryLookup)) {
              return { ...el, isSelected: true };
            }
            return { ...el, isSelected: false };
          } else {
            if (el.name === lookupPlaceHolderName(activeSourceInfo)) {
              return { ...el, isSelected: true };
            } else return { ...el, isSelected: false };
          }
        });

        if (dataSourcesWithSelectedPlatform.every((el) => el.isSelected === false)) {
          const Pname = lookupPlaceHolderName(activeSourceInfo);

          // Remove placeholder instead of showing error
          if (removeItemFromList && element?.id) {
            removeItemFromList(element.id);
          }
        } else {
          // setQueryError(''); // Removed - don't reset error here
          const dataSourcesWithSelectedMetrics = dataSourcesWithSelectedPlatform.map((el) => {
            if (el.isSelected) {
              const newMetrics = el.metrics?.map((el) => {
                const findMetric = metrics?.find((metric) => metric?.column === el.metric);
                if (findMetric) {
                  el.isSelected = true;
                  el.detailedMetric = findMetric;
                  return el;
                } else return { ...el, isSelected: false };
              });

              const newDimensions = el.dimensions?.map((el) => {
                const findDimension = dimensions?.find((dimension) => dimension?.column === el.dimension);
                if (findDimension) {
                  el.isSelected = true;
                  el.detailedDimension = findDimension;

                  return el;
                } else return { ...el, isSelected: false };
              });
              const newCalcMetrics = el.calcMetrics?.map((el) => {
                const findCalcMetric = calcMetrics?.find((calcMetric) => calcMetric?.query === el.query);
                if (findCalcMetric) {
                  el.isSelected = true;
                  el.id = Math.floor(Math.random() * Date.now()).toString();
                  // el.name = findCalcMetric.name;

                  return el;
                } else return { ...el, isSelected: false };
              });
              return { ...el, metrics: newMetrics, dimensions: newDimensions, calcMetrics: newCalcMetrics };
            } else return el;
          });
          if (ccQuery) {
            const ccFilter = ccQuery.query.filters?.find(
              (el) =>
                el?.column === 'conversion_name' ||
                el?.column === 'filter_name' ||
                el?.column === 'activity' ||
                el?.column === 'floodlight_activity_name',
            );
            if (ccFilter) {
              const ccMetricsList = ccFilter?.filter?.list;
              const dataSurcesWithSelectedMetricsAndCC = dataSourcesWithSelectedMetrics.map((el) => {
                if (el.isSelected) {
                  const newCC = el.customConversions?.map((el) => {
                    if (ccMetricsList?.includes(el.CCname)) {
                      return { ...el, isSelected: true };
                    } else return { ...el, isSelected: false };
                  });
                  return { ...el, customConversions: newCC };
                } else return el;
              });
              const selectedplatform = dataSurcesWithSelectedMetricsAndCC.find((el) => el.isSelected);
              if (selectedplatform?.customConversions?.every((el) => el.isSelected === false)) {
                setQueryError(`Some or all custom conversions are not available for this campaign`);
              } else {
                setPlaceHolderDataSource(dataSurcesWithSelectedMetricsAndCC);
              }
            }
          } else {
            setPlaceHolderDataSource(dataSourcesWithSelectedMetrics);
          }
        }
      }
    } else {
      removePlaceholderfromPublishArray(componentID);
      // setPage(0);
      setPlaceHolderDataSource([]);
    } /* else if (!mainQuery && dataSources.length > 0) {
            if (placeholderId === "101" || placeholderId === "21") {
                startNewQuery()
            }
        } */
  }, [ccQuery, dataSources, mainQuery]);

  // CUSTOM HOOK IN WHICH WE SEND DATA, STATUS, ISGRAPH AND CREATE A DATA JSON
  const [joinedData] = useJoinData(
    mainData as any[] | undefined,
    mainTotalData as any[] | undefined,
    ccData as any[] | undefined,
    ccTotalData as any[] | undefined,
    benchmarkData as any[] | undefined,
    benchmarkTotalData as any[] | undefined,
    isGraph,
    mainQueryStatus,
    mainTotalQueryStatus,
    ccQueryStatus,
    ccTotalQueryStatus,
    benchmarkQueryStatus,
    benchmarkTotalQueryStatus,
    chartMetrics,
    setChartMetrics,
    componentID,
    newQuery,
    defaultSelected,
    benchmarkIndex,
  );

  // console.log(componentID, userMainQuery)
  // console.log("placeHolderDataSource", placeHolderDataSource)
  const [publishPlaceholderObject, setPublishPlaceholderObject] = useState<PlaceholderObject>();

  const nextPage = () => {
    setPage(page + 1);
  };
  // console.log('PLACEHOLDERDATA', placeHolderDataSource);
  const previousPage = () => {
    setPage(page - 1);
  };
  // START QUERY ON CLICK AND ADD ICONS TO DATA SOURCES
  const startNewQuery = () => {
    const clonedDataSources = dataSources.map((el) => {
      return {
        ...structuredClone(el),
        icon: platformLogoSelector(el.name),
      } as placeholderFullSources;
    });
    setPlaceHolderDataSource(clonedDataSources);
    // setChartMetrics([]);
    setPage(1);
    resetQueries();
    // setTimeout(() => {
    //   setPage(0);
    // }, 100);
  };
  const [newPlatformSelected, setNewPlatformSelected] = useState<boolean>(false);
  // SELECT PLATFORM
  const selectSource = (event: ChangeEvent<HTMLInputElement>) => {
    setChartMetrics([]);

    if (userMainQuery) {
      setUserMainQuery(undefined);
      setNewPlatformSelected(true);
    }

    const addSource = () => {
      const listWithAddeDSelected = placeHolderDataSource.map((el) => {
        if (el.name === event.target.value) {
          return { ...el, isSelected: true };
        } else {
          if (el.isSelected) {
            return el;
          } else {
            return { ...el, isSelected: false };
          }
        }
      });

      const howManySelected = listWithAddeDSelected.filter((el) => el.isSelected).length;
      if (howManySelected === 1) {
        setPlaceHolderDataSource(listWithAddeDSelected);
      } else if (howManySelected > 1) {
        // Logic THAT WILL SELECT A CUSTOM PLATFORM THAT IS A COMBINATION OF SELECTED PLATFORMS
        const q = updateCustomSource(listWithAddeDSelected);
        setPlaceHolderDataSource(q as placeholderFullSources[]);
      }
    };

    const removeSource = () => {
      const a = placeHolderDataSource.map((el) => {
        if (el.name === event.target.value) {
          return { ...el, isSelected: false };
        } else {
          if (el.isSelected) {
            return el;
          } else {
            return { ...el, isSelected: false };
          }
        }
      });
      const howManySelected = a.filter((el) => el.isSelected).length;
      if (howManySelected < 2) {
        setPlaceHolderDataSource(a);
      } else if (howManySelected > 1) {
        const q = updateCustomSource(a);
        setPlaceHolderDataSource(q as placeholderFullSources[]);
      }
    };

    event.target.checked ? addSource() : removeSource();

    // placeHolderDataSource.map((el) => (el.name === source ? (el.isSelected = true) : (el.isSelected = false)));
    // // add isSelectedFalse property to all metrics and dimensions and calcMetrics
    // const a = placeHolderDataSource.map((el) => {
    //     if (el.isSelected) {
    //         const newMetrics = el.metrics?.map((el) => {
    //             return { ...el, isSelected: false };
    //         });
    //         const newDimensions = el.dimensions?.map((el) => {
    //             return { ...el, isSelected: false };
    //         });
    //         const newCalcMetrics = el.calcMetrics?.map((el) => {
    //             return { ...el, isSelected: false };
    //         });
    //         return { ...el, metrics: newMetrics, dimensions: newDimensions, calcMetrics: newCalcMetrics };
    //     } else return el;
    // });
    // setPlaceHolderDataSource(a);
  };
  // CONTUNUUE AFTER SELECTING PLAFORMS
  const handlePlatformsContinue = () => {
    const selectedPlatform = placeHolderDataSource.filter((el) => el.isSelected);
    if (selectedPlatform.length === 1) {
    } else if (selectedPlatform.length > 1) {
      const a = placeHolderDataSource.map((el) => {
        if (el.name === 'Custom') {
          return { ...el, isSelected: true };
        } else {
          return { ...el, isSelected: false };
        }
      });
      setDefaultSelected(false);
      setPlaceHolderDataSource(a);
    }
    nextPage();
  };

  // SELECT DIMENSION
  const selectDimension = (event: ChangeEvent<HTMLInputElement>) => {
    const addDimension = () => {
      const detailedDimension = {
        column: event.target.name,
        hidden: false,
        id: Math.floor(Math.random() * Date.now()).toString(),
        name: event.target.name,
      };

      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newDimensions = el.dimensions?.map((el) => {
            if (el.dimension === event.target.name) {
              return {
                ...el,
                isSelected: true,
                detailedDimension: detailedDimension,
              };
            } else {
              return el;
            }
          });
          return { ...el, dimensions: newDimensions };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };

    const removeDimension = () => {
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newDimensions = el.dimensions?.map((el) => {
            if (el.dimension === event.target.name) {
              delete el.detailedDimension;
              return {
                ...el,
                isSelected: false,
              };
            } else {
              return el;
            }
          });
          return { ...el, dimensions: newDimensions };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };

    event.target.checked ? addDimension() : removeDimension();
  };
  //GOING BACK TO BLATFORM SELECTion
  // const handleDimensionsBack = () => {
  //     const a = placeHolderDataSource.map((el) => {

  //     setPage(page - 1);
  // }

  const toggleHiddenDimension = (dimensionColumn: string) => {
    const a = placeHolderDataSource.map((el) => {
      if (el.isSelected) {
        const newDimensions = el.dimensions?.map((el) => {
          if (el.dimension === dimensionColumn) {
            return { ...el, detailedDimension: { ...el.detailedDimension, hidden: false } };
          } else return el;
          // return { ...el, detailedDimension: { ...el.detailedDimension, hidden: false } }
        });
        return { ...el, dimensions: newDimensions };
      } else return el;
    });
    setPlaceHolderDataSource(a as placeholderFullSources[]);
  };
  // SELECT METRIC
  const selectMetric = (event: ChangeEvent<HTMLInputElement>) => {
    const addMetric = () => {
      const detailedMetric: metric = {
        column: event.target.name === 'End date' || event.target.name === 'Start date' ? 'date' : event.target.name,
        name: event.target.name,
        aggregation:
          event.target.name.endsWith('_reach') ||
          event.target.name.endsWith('_recallers') ||
          event.target.name.startsWith('sub_rf_') ||
          event.target.name === 'effective_frequency' ||
          event.target.name === 'reach' ||
          event.target.name === 'frequency' ||
          event.target.name === 'date' ||
          event.target.name === 'End date'
            ? metricFunction.MAX
            : event.target.name === 'Start date'
              ? metricFunction.MIN
              : metricFunction.SUM,
        id: Math.floor(Math.random() * Date.now()).toString(),
        decimals:
          event.target.name === 'Start date' || event.target.name === 'End date'
            ? -1
            : event.target.name === 'impressions' || event.target.name === 'clicks'
              ? 0
              : 2,
      };
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newMetrics = el.metrics?.map((el) => {
            if (el.metric === event.target.name) {
              return {
                ...el,
                isSelected: true,
                detailedMetric: detailedMetric,
              };
            } else {
              return el;
            }
          });
          return { ...el, metrics: newMetrics };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    const removeMetric = () => {
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newMetrics = el.metrics?.map((el) => {
            if (el.metric === event.target.name) {
              delete el.detailedMetric;
              return {
                ...el,
                isSelected: false,
              };
            } else {
              return el;
            }
          });
          return { ...el, metrics: newMetrics };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    event.target.checked ? addMetric() : removeMetric();
  };
  // SELECT CALC METRIC
  const selectCalcMetric = (metric: ChangeEvent<HTMLInputElement>) => {
    const addCalcMetric = () => {
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newCalcMetrics = el.calcMetrics?.map((el) => {
            if (el.query === metric.target.value) {
              return {
                ...el,
                isSelected: true,
                decimals: 2,
                id: Math.floor(Math.random() * Date.now()).toString(),
              };
            } else {
              return el;
            }
          });
          return { ...el, calcMetrics: newCalcMetrics };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    const removeCalcMetric = () => {
      // if (chartMetrics.length > 0) {
      //     const arr = chartMetrics.filter(el => el.metric !== metric.target.value);
      //     setChartMetrics(arr);
      // }
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newCalcMetrics = el.calcMetrics?.map((el) => {
            if (el.query === metric.target.value) {
              delete el.decimals;
              return {
                ...el,
                isSelected: false,
              };
            } else {
              return el;
            }
          });
          return { ...el, calcMetrics: newCalcMetrics };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    metric.target.checked ? addCalcMetric() : removeCalcMetric();
  };
  // SELECT CC
  const selectCustomConversion = (event: ChangeEvent<HTMLInputElement>) => {
    const addCC = () => {
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newCC = el.customConversions?.map((el) => {
            if (el.CCname === event.target.name) {
              return {
                ...el,
                isSelected: true,
              };
            } else {
              return el;
            }
          });
          return { ...el, customConversions: newCC };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    const removeCC = () => {
      // if (chartMetrics.length > 0) {
      //     const arr = chartMetrics.filter((el) => el.metric !== event.target.name);
      //     setChartMetrics(arr);
      // }
      const a = placeHolderDataSource.map((el) => {
        if (el.isSelected) {
          const newCC = el.customConversions?.map((el) => {
            if (el.CCname === event.target.name) {
              return {
                ...el,
                isSelected: false,
              };
            } else {
              return el;
            }
          });
          return { ...el, customConversions: newCC };
        } else return el;
      });
      setPlaceHolderDataSource(a);
    };
    event.target.checked ? addCC() : removeCC();
  };

  //PREP USER QUERY ON FETCH
  const prepUserQuery = () => {
    //TODO ovdje je zeznuto ako se promjeni ime dimensiona - trebam ukljucit tu promjenu i u benchmark query
    const selectedPlatform = placeHolderDataSource.find((el) => el.isSelected);
    delete selectedPlatform?.icon;
    const copyofSelectedPlatform = structuredClone(selectedPlatform) as placeholderFullSources;
    const q = structuredClone(
      prepQuery(copyofSelectedPlatform as placeholderFullSources, isGraph, activeCampaign, user),
    );
    let shouldDeleteBenchmark = false;
    //SET MAIN QUERY
    if (userMainQuery) {
      q.query.detailedDimensions = q.query.detailedDimensions?.map((d) => {
        const findDimension = userMainQuery.query.detailedDimensions?.find((el) => el?.column === d?.column);
        if (findDimension) {
          // chek if property hidden is different in findDimension and d
          // if it is different set it to the value of d
          if (findDimension.hidden !== d?.hidden) {
            return { ...findDimension, hidden: d?.hidden as boolean, id: d?.id };
          } else {
            return { ...findDimension, id: d?.id };
          }
          // return findDimension;
        } else {
          return d;
        }
      });
      q.query.metrics = q.query.metrics?.map((m) => {
        const findMetric = userMainQuery.query.metrics?.find((el) => el?.column === m?.column);
        if (findMetric) {
          return { ...findMetric, id: m?.id };
        } else {
          return m;
        }
      });
      q.query.filters = userMainQuery.query.filters
        ?.map((f) =>
          f?.column === 'campaign_id' ||
          f?.column === 'date' ||
          selectedPlatform?.dimensions?.filter((d) => d?.isSelected).some((d) => d?.dimension === f?.column)
            ? f
            : null,
        )
        .filter((f) => f !== null) as any;
    }
    // map  q.query.orderBy and look for the same string in userMainQuery.query.orderBy
    // if it exists place it on the same index as in userMainQuery.query.orderBy
    // if it does not exist place it on the end of the array

    // KEEP RENAMED CALCULATED METRIC WHEN CLICKING BACK
    q.query.calculatedMetrics = q.query.calculatedMetrics?.map((m) => {
      const findMetric = userMainQuery?.query.calculatedMetrics?.find((el) => el?.query === m?.query);
      if (findMetric) {
        return { ...findMetric, id: m?.id };
      } else {
        return m;
      }
    });
    // console.log('KVERIMAIN', q);

    setUserMainQuery(q);

    // Sync benchmark query with main query changes if benchmark exists
    if (userBenchmarkQuery) {
      const updatedBenchmarkQuery = { ...userBenchmarkQuery };
      let benchmarkHasChanges = false;

      // Helper function to check if dimension is benchmarkable
      const isDimensionBenchmarkable = (columnName: string) => {
        const matchingSourceDimension = selectedPlatform?.dimensions?.find((d) => d?.dimension === columnName);
        if (matchingSourceDimension) {
          // Check if benchmarkable exists directly on the dimension
          if (matchingSourceDimension.hasOwnProperty('benchmarkable')) {
            return (matchingSourceDimension as any).benchmarkable !== false;
          }
          // Check if benchmarkable exists in detailedDimension
          if (
            matchingSourceDimension.detailedDimension &&
            (matchingSourceDimension.detailedDimension as any).hasOwnProperty('benchmarkable')
          ) {
            return (matchingSourceDimension.detailedDimension as any).benchmarkable !== false;
          }
        }
        // If no matching dimension found or no benchmarkable property, default to true
        return true;
      };

      // Update dimensions in benchmark query to match main query
      updatedBenchmarkQuery.query.detailedDimensions = updatedBenchmarkQuery.query.detailedDimensions?.map(
        (benchmarkDim: any) => {
          const mainDim = q.query.detailedDimensions?.find((mainD: any) => mainD.column === benchmarkDim.column);
          if (mainDim && (mainDim.name !== benchmarkDim.name || mainDim.hidden !== benchmarkDim.hidden)) {
            benchmarkHasChanges = true;
            return {
              ...benchmarkDim,
              name: mainDim.name,
              hidden: mainDim.hidden,
            };
          }
          return benchmarkDim;
        },
      );

      // Add new dimensions from main query to benchmark query if they don't exist and are benchmarkable
      const newDimensions = q.query.detailedDimensions?.filter((mainDim: any) => {
        const existsInBenchmark = updatedBenchmarkQuery.query.detailedDimensions?.some(
          (benchmarkDim: any) => benchmarkDim.column === mainDim.column,
        );
        const isBenchmarkable = isDimensionBenchmarkable(mainDim.column);
        return !existsInBenchmark && isBenchmarkable;
      });

      if (newDimensions && newDimensions.length > 0) {
        benchmarkHasChanges = true;
        updatedBenchmarkQuery.query.detailedDimensions = [
          ...(updatedBenchmarkQuery.query.detailedDimensions || []),
          ...newDimensions,
        ];
      }

      // Remove dimensions from benchmark query that are no longer in main query or not benchmarkable
      const filteredBenchmarkDimensions = updatedBenchmarkQuery.query.detailedDimensions?.filter(
        (benchmarkDim: any) => {
          const existsInMain = q.query.detailedDimensions?.some(
            (mainDim: any) => mainDim.column === benchmarkDim.column,
          );
          const isBenchmarkable = isDimensionBenchmarkable(benchmarkDim.column);
          return existsInMain && isBenchmarkable;
        },
      );

      if (filteredBenchmarkDimensions?.length !== updatedBenchmarkQuery.query.detailedDimensions?.length) {
        benchmarkHasChanges = true;
        updatedBenchmarkQuery.query.detailedDimensions = filteredBenchmarkDimensions;
      }

      // Remove calculated metrics from benchmark query if they no longer exist in main query
      const filteredBenchmarkCalcMetrics = updatedBenchmarkQuery.query.calculatedMetrics?.filter(
        (benchmarkCalc: any) => {
          return q.query.calculatedMetrics?.some((mainCalc: any) => mainCalc.query === benchmarkCalc.query);
        },
      );

      if (filteredBenchmarkCalcMetrics?.length !== updatedBenchmarkQuery.query.calculatedMetrics?.length) {
        benchmarkHasChanges = true;
        updatedBenchmarkQuery.query.calculatedMetrics = filteredBenchmarkCalcMetrics;
      }

      // If no calculated metrics remain in benchmark query, mark for deletion but continue
      if (
        !updatedBenchmarkQuery.query.calculatedMetrics ||
        updatedBenchmarkQuery.query.calculatedMetrics.length === 0
      ) {
        // We'll delete benchmark queries at the end to not interrupt the main query flow
        shouldDeleteBenchmark = true;
      }

      // Update orderBy to match filtered dimensions and preserve existing metrics/calc metrics
      if (benchmarkHasChanges) {
        const dimensionIds = updatedBenchmarkQuery.query.detailedDimensions?.map((dim: any) => dim.id) || [];
        const metricIds = updatedBenchmarkQuery.query.metrics?.map((metric: any) => metric.id) || [];
        const calcMetricIds = updatedBenchmarkQuery.query.calculatedMetrics?.map((calc: any) => calc.id) || [];

        // First, clean existing orderBy to remove invalid IDs
        const cleanedOrderBy =
          updatedBenchmarkQuery.query.orderBy?.filter(
            (id: string | null) =>
              id && (dimensionIds.includes(id) || metricIds.includes(id) || calcMetricIds.includes(id)),
          ) || [];

        // Then, add any new dimension IDs that are not already in orderBy
        const newDimensionIds = dimensionIds.filter((dimId) => !cleanedOrderBy.includes(dimId));

        updatedBenchmarkQuery.query.orderBy = [...cleanedOrderBy, ...newDimensionIds];
        setUserBenchmarkQuery(updatedBenchmarkQuery);
      }
    }

    if (
      selectedPlatform?.customConversions?.length !== 0 &&
      selectedPlatform?.customConversions?.some((el) => el.isSelected)
    ) {
      const CCq = prepQueryCC(selectedPlatform as placeholderFullSources, isGraph, activeCampaign, user);
      // SET CC QUERY
      if (userCCQuery) {
        //CCq.query.filters = userCCQuery.query.filters;
        CCq.query.metrics = CCq.query.metrics?.map((m) => {
          const findMetric = userCCQuery.query.metrics?.find((el) => el?.column === m?.column);
          if (findMetric) {
            return { ...findMetric, id: m?.id };
          } else {
            return m;
          }
        });
        CCq.query.detailedDimensions = CCq.query.detailedDimensions?.map((d) => {
          const findDimension = userCCQuery.query.detailedDimensions?.find((el) => el?.column === d?.column);
          if (findDimension) {
            return { ...findDimension, id: d?.id };
          } else {
            return d;
          }
        });
      }

      // KEEP RENAMED CALCULATED METRIC WHEN CLICKING BACK
      CCq.query.calculatedMetrics = CCq.query.calculatedMetrics?.map((m) => {
        const findMetric = userCCQuery?.query.calculatedMetrics?.find((el) => el?.query === m?.query);
        if (findMetric) {
          return { ...findMetric, id: m?.id };
        } else {
          return m;
        }
      });
      // console.log('KVERICC', CCq);
      setUserCCQuery(CCq);
    } else {
      setUserCCQuery(undefined);
    }

    if (!isGraph) {
      const sourceObjectTotal = structuredClone(selectedPlatform) as placeholderFullSources;
      sourceObjectTotal.dimensions = sourceObjectTotal.dimensions?.map((d) => {
        if (d.dimension === 'client_code') {
          return {
            ...d,
            isSelected: true,
            detailedDimension: {
              column: 'client_code',
              hidden: false,
              id: Math.floor(Math.random() * Date.now()).toString(),
              name: 'campaign_id',
            },
          };
        } else {
          return { ...d, isSelected: false };
        }
      });

      const qTotal = prepQuery(sourceObjectTotal as placeholderFullSources, isGraph, activeCampaign, user);
      if (userMainQueryTotal) {
        // qTotal.query.detailedDimensions = qTotal.query.detailedDimensions?.map((d) => {
        //     const findDimension = userMainQueryTotal.query.detailedDimensions?.find((el) => el?.column === d?.column);
        //     if (findDimension) {
        //         return findDimension;
        //     } else {
        //         return d;
        //     }
        // });
        qTotal.query.metrics = qTotal.query.metrics?.map((m) => {
          const findMetric = userMainQueryTotal.query.metrics?.find((el) => el?.column === m?.column);
          if (findMetric) {
            return { ...findMetric, id: m?.id };
          } else {
            return m;
          }
        });
        // qTotal.query.filters = userMainQueryTotal.query.filters;
      }
      qTotal.query.calculatedMetrics = qTotal.query.calculatedMetrics?.map((m) => {
        const findMetric = userMainQueryTotal?.query.calculatedMetrics?.find((el) => el?.query === m?.query);
        if (findMetric) {
          return { ...findMetric, id: m?.id };
        } else {
          return m;
        }
      });
      qTotal.query.calculatedMetrics = qTotal.query.calculatedMetrics?.map((element: any) =>
        element.query.includes('/MAX')
          ? {
              ...element,
              query: element.query.slice(0, element.query.indexOf('/')).concat('/MAX(#campaign_mapping_reach)'),
            }
          : element,
      );

      if (
        qTotal.query.filters?.some(
          (el) => el?.column === 'campaign_id' && (el?.filter as any)?.list && (el?.filter as any)?.list?.length > 1,
        )
      ) {
        qTotal.query.nullColumns = ['campaign_mapping_reach'];
      }

      const isFacebook = qTotal.views[0]?.viewName.includes('facebook') ? true : false;
      const isSnapchat = qTotal.views[0]?.viewName.includes('snapchat') ? true : false;
      const isDV360 = qTotal.views[0]?.viewName.includes('dv360')  ? true : false;
      qTotal.query.metrics = qTotal.query.metrics?.map((element: any) =>
        element.column.endsWith('reach') && (isFacebook || isSnapchat || isDV360)
          ? { ...element, column: 'campaign_mapping_reach' }
          : element,
      );
      // console.log('KVERIMAINTOTAL', qTotal);
      setUserMainQueryTotal(qTotal);
      if (
        selectedPlatform?.customConversions?.length !== 0 &&
        selectedPlatform?.customConversions?.some((el) => el.isSelected)
      ) {
        const CCqTotal = prepQueryCC(sourceObjectTotal as placeholderFullSources, isGraph, activeCampaign, user);
        if (userCCTotalQuery) {
          CCqTotal.query.metrics = CCqTotal.query.metrics?.map((m) => {
            const findMetric = userCCTotalQuery.query.metrics?.find((el) => el?.column === m?.column);
            if (findMetric) {
              return { ...findMetric, id: m?.id };
            } else {
              return m;
            }
          });
          // CCqTotal.query.detailedDimensions = userCCTotalQuery.query.detailedDimensions?.map((d) => {
          //     const findDimension = userCCTotalQuery.query.detailedDimensions?.find((el) => el?.column === d?.column);
          //     if (findDimension) {
          //         return findDimension;
          //     } else {
          //         return d;
          //     }
          // });
        }

        // KEEP RENAMED CALCULATED METRIC WHEN CLICKING BACK
        CCqTotal.query.calculatedMetrics = CCqTotal.query.calculatedMetrics?.map((m) => {
          const findMetric = userCCTotalQuery?.query.calculatedMetrics?.find((el) => el?.query === m?.query);
          if (findMetric) {
            return { ...findMetric, id: m?.id };
          } else {
            return m;
          }
        });
        // console.log('KVERICCTOTAL', CCqTotal);
        setUserCCTotalQuery(CCqTotal);
      }
    }
    if (newQuery !== 'BACK') {
      setNewQuery('NEW');
    }

    if (element?.duplicated === true) {
      updateTablePlaceholderDuplicate && updateTablePlaceholderDuplicate(mainQueryID, element.id, false, element.id);
    }

    setNewPlatformSelected(false);
    setPage(6);

    // Delete benchmark queries at the end if marked for deletion
    if (shouldDeleteBenchmark) {
      setUserBenchmarkQuery(undefined);
      setUserBenchmarkTotalQuery(undefined);
    }
  };
  // THIS MIGHT BE BACK A BUTTON ISSUE
  useEffect(() => {
    //TODO: check if this is needed page === 0
    if (storedQueryDetails && !joinedData && !newPlatformSelected && page === 0) {
      // // Don't auto-navigate when user is starting fresh (no stored query and no main query)
      // // OR when user explicitly requested NEW query (reset scenario)
      // if ((!storedQueryDetails && !userMainQuery && page === 0) || (newQuery === 'NEW' && !userMainQuery)) {
      //   return; // Stay on current page for fresh start or reset
      // }

      // if (storedQueryDetails && !joinedData && !newPlatformSelected && page === 0 && newQuery !== 'NEW') {
      setPage(6);
    } else if (storedQueryDetails && joinedData && !newPlatformSelected) {
      setTitle(storedQueryDetails?.title);
      // newQuery ? setPage(6) : setPage(7);

      // Don't change page if only benchmark index changed
      if (benchmarkChangeRef.current) {
        return;
      }

      if (element?.duplicated === true) {
        isPlaceholderSaved === false ? setPage(6) : setPage(7);
      } else {
        setPage(
          (newQuery !== 'OLD' || fetchedPlaceholders.length > 0) &&
            (dashType === DashboardTypes.INSOURCE_DATA ||
              dashType === DashboardTypes.DIGITAL ||
              dashType === DashboardTypes.SEARCH)
            ? 6
            : 7,
        );
      }
    }
    // Don't change page if no stored query details and user is starting fresh
  }, [storedQueryDetails, joinedData, newQuery, fetchedPlaceholders.length, dashType]);
  // Track benchmark index changes
  useEffect(() => {
    benchmarkChangeRef.current = true;
    const timer = setTimeout(() => {
      benchmarkChangeRef.current = false;
    }, 200);
    return () => clearTimeout(timer);
  }, [benchmarkIndex]);

  // : isPlaceholderSaved === false ? 6

  // console.log("What page is this one ??", element)

  useEffect(() => {
    // updata olarray was for some reason inside if statement. I didnt delete it because I am not sure if it is needed
    // update olarray used to be inside of the if statemetn, i kept the code because i am not sure if it will work
    if (
      ![mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].includes('RUNNING') &&
      ![mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].includes('FAILED')
    ) {
      if (!isGraph) {
        if (ccQueryStatus === 'NOT STARTED') {
          if (mainOL && mainOLTotal) {
            const placeholdersObject = {
              position: placeholderId,
              outputlocation: mainOL,
              outputlocationTotal: mainOLTotal,
              ...(benchmarkOL && { outputlocation_benchmark: benchmarkOL }),
              ...(benchmarkOLTotal && { outputlocationTotal_benchmark: benchmarkOLTotal }),
              ...(benchmarkIndex && { benchmarkingIndex: benchmarkIndex as BenchmarkingIndexValues }),
              title: storedQueryDetails?.title ?? title,
            };
            if (
              (newQuery === 'OLD' && storedQueryDetails && fetchedPlaceholders.length === 0) ||
              (page === 7 && (newQuery === 'NEW' || (newQuery === 'OLD' && fetchedPlaceholders.length > 0)))
            ) {
              updateOLArray(placeholdersObject);
            } else {
              setPublishPlaceholderObject(placeholdersObject);
            }
          }
        } else if (ccQueryStatus === 'DONE' && ccTotalQueryStatus === 'DONE') {
          if (mainOL && mainOLTotal && ccOL && ccOLTotal) {
            const placeholdersObject = {
              position: placeholderId,
              outputlocation: mainOL,
              outputlocationTotal: mainOLTotal,
              outputlocation_cc: ccOL,
              outputlocationTotal_cc: ccOLTotal,
              ...(benchmarkOL && { outputlocation_benchmark: benchmarkOL }),
              ...(benchmarkOLTotal && { outputlocationTotal_benchmark: benchmarkOLTotal }),
              ...(benchmarkIndex && { benchmarkingIndex: benchmarkIndex as BenchmarkingIndexValues }),
              title: storedQueryDetails?.title ?? title,
            };
            if (
              (newQuery === 'OLD' && storedQueryDetails && fetchedPlaceholders.length === 0) ||
              (page === 7 && (newQuery === 'NEW' || (newQuery === 'OLD' && fetchedPlaceholders.length > 0)))
            ) {
              updateOLArray(placeholdersObject);
            } else {
              setPublishPlaceholderObject(placeholdersObject);
            }
          }
        }
      } else if (isGraph /* && chartMetrics.length > 0 */) {
        if (ccQueryStatus === 'NOT STARTED') {
          if (mainOL) {
            const placeholdersObject = {
              position: placeholderId,
              outputlocation: mainOL,
              ...(benchmarkOL && { outputlocation_benchmark: benchmarkOL }),
              ...(benchmarkIndex && { benchmarkingIndex: benchmarkIndex as BenchmarkingIndexValues }),
              title: storedQueryDetails?.title ?? title,
              metrics:
                dashType === 'DIGITAL' ||
                dashType === 'SEARCH' ||
                dashType === 'INSOURCE_DATA' ||
                (dashType === 'TV' && videoSource === 'BVOD')
                  ? chartMetrics.map((m) => removeTypename(m))
                  : [],
            };
            if (
              (newQuery === 'OLD' && storedQueryDetails && fetchedPlaceholders.length === 0) ||
              (page === 7 && (newQuery === 'NEW' || (newQuery === 'OLD' && fetchedPlaceholders.length > 0)))
            ) {
              updateOLArray(placeholdersObject);
            } else {
              setPublishPlaceholderObject(placeholdersObject);
            }
          }
        } else if (ccQueryStatus === 'DONE') {
          if (mainOL && ccOL) {
            const placeholdersObject = {
              position: placeholderId,
              outputlocation: mainOL,
              outputlocation_cc: ccOL,
              ...(benchmarkOL && { outputlocation_benchmark: benchmarkOL }),
              ...(benchmarkIndex && { benchmarkingIndex: benchmarkIndex as BenchmarkingIndexValues }),
              title: storedQueryDetails?.title ?? title,
              metrics:
                dashType === 'DIGITAL' ||
                dashType === 'SEARCH' ||
                dashType === 'INSOURCE_DATA' ||
                (dashType === 'TV' && videoSource === 'BVOD')
                  ? chartMetrics.map((m) => removeTypename(m))
                  : [],
            };
            // updateOLArray(placeholdersObject);
            if (
              (newQuery === 'OLD' && storedQueryDetails && fetchedPlaceholders.length === 0) ||
              (page === 7 && (newQuery === 'NEW' || (newQuery === 'OLD' && fetchedPlaceholders.length > 0)))
            ) {
              updateOLArray(placeholdersObject);
            } else {
              setPublishPlaceholderObject(placeholdersObject);
            }
          }
        }
      }
    } else if ([mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].includes('FAILED')) {
      setQueryError('Query failed, please try again');
    } else {
      // Only clear error if it's a query-related error or empty
      if (queryError === 'Query failed, please try again' || queryError === '') {
        setQueryError('');
      }
      // Don't clear platform validation errors - preserve them
    }
  }, [
    ccOL,
    ccOLTotal,
    ccQueryStatus,
    ccTotalQueryStatus,
    benchmarkOL,
    benchmarkOLTotal,
    chartMetrics,
    dashType,
    fetchedPlaceholders.length,
    isGraph,
    mainOL,
    mainOLTotal,
    mainQueryStatus,
    mainTotalQueryStatus,
    newQuery,
    placeholderId,
    storedQueryDetails,
    title,
    updateOLArray,
    page,
    videoSource,
    benchmarkIndex,
  ]);

  const isLoading = [mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].some(
    (el) => el === 'RUNNING',
  );

  useEffect(() => {
    const statusInfo = {
      id: componentID,
      loaded: !isLoading,
    } as placeholdersStatusType;
    // in placeholdersStatus replace the object with the same id with the new one
    const index = placeholdersStatus.findIndex((el) => el.id === componentID);
    if (index !== -1) {
      const newArray = [...placeholdersStatus];
      newArray[index] = statusInfo;
      setPlaceholdersStatus(newArray);
    } else {
      setPlaceholdersStatus([...placeholdersStatus, statusInfo]);
    }
  }, [isLoading]);

  const defaultQuery = () => {
    resetQueries();
    const clonedDataSources = dataSources.map((el) => {
      return {
        ...structuredClone(el),
        icon: platformLogoSelector(el.name),
      } as placeholderFullSources;
    });
    const a = clonedDataSources.map((el) => {
      if (el.name === 'Custom') {
        return { ...el, isSelected: true };
      } else {
        return { ...el, isSelected: false };
      }
    });

    const metrics = isGraph ? ['impressions'] : ['impressions', 'clicks', 'cost'];
    const dimensions = isGraph ? ['year_week', 'data_source'] : [/* "campaign_name" */ 'data_source'];
    const calcMetrics = isGraph ? [] : ['CPC', 'CPM'];

    a.map((el) => {
      if (el.isSelected) {
        const newMetrics = el.metrics?.map((el) => {
          const findMetric = metrics?.find((metric) => metric === el.metric);
          if (findMetric) {
            el.isSelected = true;
            el.detailedMetric = {
              column: el.metric as string,
              name: el.metric as string,
              aggregation: metricFunction.SUM,
              id: Math.floor(Math.random() * Date.now()).toString(),
              decimals: 2,
            };
            return el;
          } else return { ...el, isSelected: false };
        });

        const newDimensions = el.dimensions?.map((el) => {
          const findDimension = dimensions?.find((dimension) => dimension === el.dimension);
          if (findDimension) {
            el.isSelected = true;
            el.detailedDimension = {
              column: el.dimension as string,
              name: el.dimension as string,
              hidden: false,
              id: Math.floor(Math.random() * Date.now()).toString(),
            };

            return el;
          } else return { ...el, isSelected: false };
        });
        const newCalcMetrics = el.calcMetrics?.map((el) => {
          const findCalcMetric = calcMetrics?.find((calcMetric) => calcMetric === el.name);
          if (findCalcMetric) {
            el.isSelected = true;
            el.id = Math.floor(Math.random() * Date.now()).toString();
            // el.name = findCalcMetric.name;

            return el;
          } else return { ...el, isSelected: false };
        });
        return { ...el, metrics: newMetrics, dimensions: newDimensions, calcMetrics: newCalcMetrics };
      } else return el;
    });
    setTitle(isGraph ? 'Pacing' : 'Summary');
    setPlaceHolderDataSource(a);
    setDefaultSelected(true);
    // isGraph && setChartMetrics([{
    //     __typename: "MetricsResponse",
    //     chartType: "line",
    //     metric: "impressions",
    //     axis: 0,
    // }])
  };

  useEffect(() => {
    if (defaultSelected) {
      const q = prepUserQuery();
      // if (q) {
      //     setPage(6)
      // }
    }
  }, [defaultSelected]);

  // React to newQuery changes and trigger startNewQuery when needed
  useEffect(() => {
    if (newQuery === 'NEW' && page === 0 && dataSources.length > 0 && !userMainQuery) {
      startNewQuery();
    }
  }, [newQuery, page, dataSources.length, userMainQuery]);

  // console.log("mainQ", componentID, mainQuery, mainQueryTotal , mainData)
  const { getEnvironment } = useContext(APIContext);

  const handleDeleteConfirmation = (confirmed: boolean) => {
    if (confirmed) {
      performDelete();
    }
    setShowDeleteConfirmation(false);
  };

  const handleDeletePlaceholder = () => {
    setShowDeleteConfirmation(true);
  };

  const performDelete = async () => {
    if (storedQueryDetails && element) {
      //call API
      try {
        (await API.graphql({
          query: deleteStoredQuery,
          variables: {
            campaign_id: activeCampaign?.campaignId?.toString(),
            Environment: getEnvironment,
            placeholder: element.id,
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: DeleteStoredQueryMutation };
        props.removeItemFromList !== undefined && element !== undefined && props.removeItemFromList(element.id);
      } catch (e) {
        console.log('ERROR  DELETING QUERY', e);
      }
    }
  };

  const deleteModalObject: modalObject = {
    title: 'Delete Placeholder',
    message: `Are you sure you want to delete this placeholder? This action cannot be undone.`,
    mainButton: 'Delete',
    secondaryButton: 'Cancel',
  };

  const wrongBenchmarkPeriod =
    Array.isArray(benchmarkData) &&
    Array.isArray(benchmarkTotalData) &&
    benchmarkData.length === 0 &&
    benchmarkTotalData.length === 0;

  return (
    <StyledTableContainer
      style={{
        display: 'block',
        border: isDragEnabled ? '1px solid #a1aebe' : 'none',
        borderRadius: '7px',
        // height: /* page === 6 ? (isLoading && isGraph ? '25vw' : 'auto') : isGraph ? page === 0 || page === 1 || page === 7 ? '25vw' : "auto" : */ 'auto',
        maxHeight: page === 6 ? (isLoading && isGraph ? '37vw' : '') : 'auto',
        minHeight: isGraph ? '45vh' : 'auto',
      }}
      expand={0}
    >
      <>
        {showDeleteConfirmation && (
          <DeleteConfirmationModal
            handleDeleteConfirmationModal={handleDeleteConfirmation}
            modalObject={deleteModalObject}
          />
        )}
        <div className="upAndDownContainer">
          {element && isDragEnabled && orderLength && (
            <>
              {parentIndex !== 0 && <div onClick={() => moveElement && moveElement(element.id, 'UP')}>UP</div>}
              {parentIndex !== orderLength - 1 && (
                <div onClick={() => moveElement && moveElement(element.id, 'DOWN')}>DOWN</div>
              )}
            </>
          )}
          {(userMainQuery || userCCQuery || userMainQueryTotal || userCCTotalQuery) &&
            page === 7 &&
            userIsASolutionsArchitect && (
              <button
                type="button"
                onClick={clearCache}
                style={{
                  marginLeft: '10px',
                  padding: '5px 10px',
                  backgroundColor:
                    cacheStatus === 'cleared' ? '#28a745' : cacheStatus === 'clearing' ? '#ffc107' : '#ff6b6b',
                  color: 'white',
                  border: 'none',
                  boxShadow: 'none',
                  borderRadius: '4px',
                  cursor: cacheStatus === 'clearing' ? 'not-allowed' : 'pointer',
                }}
                disabled={cacheStatus === 'clearing'}
              >
                {cacheStatus === 'clearing'
                  ? 'Clearing...'
                  : cacheStatus === 'cleared'
                    ? 'Cache Cleared'
                    : 'Clear Cache'}
              </button>
            )}
        </div>
        <>
          {activeCampaign?.authorized &&
            page !== 0 &&
            page !== 1 &&
            page !== 7 &&
            storedQueryDetails &&
            [mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].every(
              (el) => el !== 'RUNNING',
            ) &&
            ![mainQueryStatus, mainTotalQueryStatus, ccQueryStatus, ccTotalQueryStatus].every(
              (el) => el === 'NOT STARTED',
            ) && (
              <div
                style={{
                  display: 'flex',
                  gap: '10px',
                  flexDirection: 'row',
                  position: 'absolute',
                  right: '10px',
                  top: '10px',
                }}
              >
                <IconButton
                  type="button"
                  onClick={() => {
                    previousPage();
                  }}
                >
                  <span style={{ fontSize: '12px' }} className="icon material-symbols-outlined">
                    chevron_backward
                  </span>
                  Previous Page
                </IconButton>

                <IconButton
                  type="button"
                  onClick={() => {
                    handleDeletePlaceholder();
                  }}
                >
                  <span style={{ fontSize: '12px' }} className="icon material-symbols-outlined">
                    delete
                  </span>
                  Delete Placeholder
                </IconButton>
              </div>
            )}
        </>
        {page === 0 && (
          <TxtContainer2 isGraph={isGraph} displayTxt={page}>
            <Add isGraph={isGraph}>
              {placeholderId === '101' ||
              placeholderId === '201' ||
              placeholderId === 'Search101' ||
              placeholderId === 'Search201' ? (
                <>
                  <div className="text">
                    <h1>No Saved Queries</h1>
                    <h2>You can start a new query or choose a default one</h2>
                  </div>
                  <div className="actionButton">
                    <button onClick={() => startNewQuery()} type="button">
                      {` Start new ${isGraph ? 'chart' : 'table'} query +`}
                    </button>
                    <button style={{ marginLeft: '10px' }} onClick={() => defaultQuery()} type="button">
                      {` Use default query`}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="text">
                    <h1>No Saved Queries</h1>
                    <h2>If you would like to start a query, please click on the button </h2>
                  </div>
                  <div className="actionButton">
                    <button onClick={() => startNewQuery()} type="button">
                      {` Start new ${isGraph ? 'chart' : 'table'} query +`}
                    </button>
                  </div>
                </>
              )}
            </Add>
          </TxtContainer2>
        )}
        {page === 1 && (
          <PlatformContainer
            isGraph={isGraph}
            placeHolderDataSource={placeHolderDataSource}
            selectSource={selectSource}
            setPage={setPage}
            handlePlatformsContinue={handlePlatformsContinue}
            startNewQuery={startNewQuery}
          ></PlatformContainer>
        )}
        {page === 2 && (
          <DimensionsContainer
            isGraph={isGraph}
            placeHolderDataSource={placeHolderDataSource}
            selectDimension={selectDimension}
            setPage={setPage}
            nextPage={nextPage}
            previousPage={previousPage}
            startNewQuery={startNewQuery}
          ></DimensionsContainer>
        )}
        {page === 3 && (
          <MetricsContainer
            isGraph={isGraph}
            placeHolderDataSource={placeHolderDataSource}
            setPage={setPage}
            nextPage={nextPage}
            previousPage={previousPage}
            selectMetric={selectMetric}
            selectCalcMetric={selectCalcMetric}
          ></MetricsContainer>
        )}
        <ConversionsContainer
          isGraph={isGraph}
          placeHolderDataSource={placeHolderDataSource}
          setPage={setPage}
          page={page}
          nextPage={nextPage}
          previousPage={previousPage}
          selectCustomConversion={selectCustomConversion}
        ></ConversionsContainer>
        {page === 5 && (
          <OverviewContainer
            isGraph={isGraph}
            placeHolderDataSource={placeHolderDataSource}
            setPage={setPage}
            page={page}
            nextPage={nextPage}
            previousPage={previousPage}
            prepUserQuery={prepUserQuery}
            toggleHiddenDimension={toggleHiddenDimension}
          ></OverviewContainer>
        )}
        {page === 6 && (
          <div>
            {[
              mainQueryStatus,
              mainTotalQueryStatus,
              ccQueryStatus,
              ccTotalQueryStatus,
              benchmarkQueryStatus,
              benchmarkTotalQueryStatus,
            ].some((el) => el === 'RUNNING') && !joinedData ? (
              <div style={{ /* margin: 'auto' */ height: '80px' }}>
                <ReactLoading className="loaderCentered" type="spinningBubbles" color={theme.publishButton} />
              </div>
            ) : (
              <PreviewContainer
                joinedData={joinedData}
                isGraph={isGraph}
                title={title}
                setTitle={setTitle}
                page={page}
                ccData={ccData}
                userMainQuery={userMainQuery}
                userCCQuery={userCCQuery}
                nextPage={nextPage}
                previousPage={previousPage}
                chartMetrics={chartMetrics}
                setChartMetrics={(chartMetric: any) => setChartMetrics(chartMetric)}
                componentID={element?.id as string}
                element={element}
                mainQueryID={mainQueryID}
                ccQueryID={ccQueryID}
                benchmarkQueryID={benchmarkQueryID}
                queryError={queryError}
                setQueryError={(error: string) => setQueryError(error)}
                setUserMainQuery={(q: any) => setUserMainQuery(q)}
                setUserCCQuery={(q: any) => setUserCCQuery(q)}
                setUserCCTotalQuery={(q: any) => setUserCCTotalQuery(q)}
                setUserMainQueryTotal={(q: any) => setUserMainQueryTotal(q)}
                placeholderList={placeholderList}
                setStoredQueries={setStoredQueries || (() => {})}
                setTablePlaceholderList={setTablePlaceholderList || (() => {})}
                setPage={setPage}
                userBenchmarkQuery={userBenchmarkQuery}
                setUserBenchmarkQuery={(q: any) => setUserBenchmarkQuery(q)}
                setUserBenchmarkTotalQuery={(q: any) => setUserBenchmarkTotalQuery(q)}
                selectedDataSource={selectedDataSource}
                setNewQuery={(newQuery: 'OLD' | 'NEW' | 'BACK' | 'APPLY') => setNewQuery(newQuery)}
                updateTablePlaceholderDuplicate={updateTablePlaceholderDuplicate || (() => {})}
                savePlaceholderToOrder2={savePlaceholderToOrder2 || (() => {})}
                defaultSelected={defaultSelected}
                // publishPlaceholderObject={publishPlaceholderObject}
                latestOverwrittenData={activeCampaign?.authorized ? latestOverwrittenData : undefined}
                benchmarkIndex={benchmarkIndex}
                setBenchmarkIndex={setBenchmarkIndex}
                hideTotal={hideTotal}
                setHideTotal={setHideTotal}
              ></PreviewContainer>
            )}
            {wrongBenchmarkPeriod && (
              <div
                style={{
                  color: 'red',
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: '#ffeaea',
                  borderRadius: '5px',
                }}
              >
                <strong>No benchmark data available</strong>
                <br />
                {(() => {
                  const dateFilter = userBenchmarkQuery?.query.filters?.find((f) => f?.column === 'date');
                  const startDate = dateFilter?.filter?.from;
                  const endDate = dateFilter?.filter?.to;

                  return (
                    <>
                      No benchmark data was found for the selected date range
                      {startDate && endDate && (
                        <span>
                          {' '}
                          ({new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()})
                        </span>
                      )}
                      .
                      <br />
                      Please try selecting a different date period or contact support if you believe benchmark data
                      should be available for this timeframe.
                    </>
                  );
                })()}
              </div>
            )}
          </div>
        )}
        {page === 7 && (
          <SavedContainer
            joinedData={joinedData}
            isGraph={isGraph}
            title={title}
            setTitle={setTitle}
            page={page}
            ccData={ccData}
            userMainQuery={userMainQuery}
            userCCQuery={userCCQuery}
            chartMetrics={chartMetrics}
            setChartMetrics={(chartMetric: any) => setChartMetrics(chartMetric)}
            componentID={placeholderId as string}
            previousPage={previousPage}
            handleDuplicate={handleDuplicate}
            mainQueryID={mainQueryID}
            ccQueryID={ccQueryID}
            removeItemFromList={removeItemFromList}
            element={element}
            defaultSelected={defaultSelected}
            latestOverwrittenData={activeCampaign?.authorized ? latestOverwrittenData : undefined}
          ></SavedContainer>
        )}
      </>
    </StyledTableContainer>
  );
};

export default PlaceholderContainer;
